import DefaultLayout from '../../../layout/DefautlLayout';
import Header from '../../../components/header/Header';
import { Link } from 'react-router-dom';
import TreatmentIntroBanner from '../../../components/treatmentBanner/treatmentBanner';

const SclerotherapyPage = () => {
	const prices = [{ label: 'Treatment', value: 'Price on Consult' }];

	return (
		<DefaultLayout>
			<Header />
			<div id="Content">
				<div className="content_wrapper clearfix">
					<div className="sections_group">
						<div className="extra_content">
							<TreatmentIntroBanner
								title="Sclerotherapy"
								description="A minimally invasive treatment for spider and small varicose veins using a sclerosant solution to collapse veins—improving appearance, reducing discomfort, and promoting smoother, healthier-looking skin."
								quote=" Restore confidence with smoother, clearer skin. "
								backgroundImage="/assets/images/banners/treatment-xl-2.png"
							/>

							<div className="section mcb-section" style={{ paddingBottom: '70px' }}>
								<div className="section_wrapper mcb-section-inner">
									<div className="wrap mcb-wrap one valign-top clearfix">
										<div className="mcb-wrap-inner">
											<div className="column mcb-column one-third column_image">
												<div className="image_frame image_item scale-with-grid aligncenter has_border hrmargin_b_30">
													<div className="image_wrapper">
														<div className="mask"></div>
														<img
															className="scale-with-grid"
															src="/assets/images/treatments/sclerotherapy.jpg"
															alt="Sclerotherapy Procedure"
															width="960"
															height="960"
														/>
													</div>
												</div>
											</div>

											<div className="column mcb-column two-third column_column">
												<div className="column_attr clearfix">
													<h4>How It Works</h4>
													<p>
														A sclerosant solution is injected directly into the vein, causing the vein walls to collapse and stick
														together. Over time, the treated vein fades as the body absorbs it.
													</p>

													<h4>What to Expect</h4>
													<p>
														Treatment sessions typically last 15–45 minutes. You may need multiple sessions depending on the number
														and size of veins. You’ll be asked to walk and wear compression stockings after the treatment.
													</p>

													<h4>Benefits</h4>
													<ul>
														<li>Minimally invasive with little downtime</li>
														<li>Improves appearance of spider and varicose veins</li>
														<li>Relieves associated symptoms like aching, swelling, or cramps</li>
													</ul>

													<h4>Possible Side Effects</h4>
													<ul>
														<li>Temporary redness, swelling, or bruising at injection sites</li>
														<li>Itching or discomfort for a few days</li>
														<li>Rarely: skin discolouration, allergic reaction, or blood clots</li>
													</ul>
												</div>
											</div>

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<div className="column one column_pricing_item">
														<div className="pricing-box custom-pricing-box pricing-box-table pricing-box-featured">
															<div className="plan-header">
																<h3>Pricing</h3>
															</div>
															<div className="plan-inside clearfix">
																<hr className="bg-theme" />
																<ul>
																	{prices.map(({ label, value }, idx) => (
																		<li key={idx} className="clearfix" style={{ paddingLeft: '5%', paddingRight: '5%' }}>
																			<div>
																				<strong>{label}</strong>
																			</div>
																			<div style={{ whiteSpace: 'pre-line' }}>{value}</div>
																		</li>
																	))}
																</ul>
																<hr className="bg-theme" />
															</div>
															<div className="plan-footer">
																<Link to="/book-now" className="button button_left button_theme button_js">
																	<span className="button_icon">
																		<i className="icon-basket"></i>
																	</span>
																	<span className="button_label">BOOK NOW</span>
																</Link>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="column mcb-column one column_divider">
												<hr className="no_line" />
											</div>

											<div className="column one column_slider">
												<div className="column_attr clearfix hrmargin_b_60">
													<h2 className="hrmargin_b_60" style={{ textAlign: 'center' }}>
														Results
													</h2>
													<div className="content_slider">
														<ul className="content_slider_ul">
															<li className="content_slider_li_1">
																<img
																	width="100%"
																	height="auto"
																	src="/assets/images/treatments/sclerotherapy-result.jpg"
																	alt="Sclerotherapy Results"
																	className="scale-with-grid wp-post-image"
																/>
															</li>
														</ul>
													</div>
												</div>
											</div>

											<div className="column mcb-column one column_divider">
												<hr className="no_line" />
											</div>

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<h2 className="hrmargin_b_60" style={{ textAlign: 'center' }}>
														After-Care
													</h2>
													<ul>
														<li>
															Wear compression stockings or bandages for several days post-treatment to help collapse the treated
															veins.
														</li>
														<li>
															Walk daily to improve circulation, but avoid strenuous exercise, sun exposure, and hot baths for 48
															hours.
														</li>
														<li>
															Avoid applying lotion or creams on the treated areas immediately after treatment unless directed.
														</li>
														<li>
															If you experience leg pain, swelling, discolouration, or a sudden rash, contact your provider
															promptly.
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</DefaultLayout>
	);
};

export default SclerotherapyPage;
